import React from 'react'
import './FirefoxButton.scss'

const FirefoxButton = function(props) {
  return (
    <a href="/ff_signin?s=pocket&t=login" className="login-btn-firefox">
      <span className="logo"></span>
      <span className="text">{ props.text }</span>
    </a>
  )
}

export { FirefoxButton }
